module.exports = __webpack_public_path__ + "img/00038.eccb9931.webp";